import React from "react";
import HeadsetMicIcon from "@material-ui/icons/HeadsetMic";
import { useTranslation } from "react-i18next";

const SmallHelp = ({ classes }) => {
  const { i18n } = useTranslation();
  return (
    <ul
      className={
        i18n.language === "en"
          ? classes.miniContainerLtr
          : classes.miniContainer
      }
      style={{ position: "relative" }}
    >
      <li className={classes.menuItemHelp}>
        <HeadsetMicIcon
          className={classes.icons}
          style={{ margin: "1px" }}
          fontSize={"small"}
        />
      </li>
    </ul>
  );
};

export default SmallHelp;
